const DIAS = [
  'domingo',
  'segunda-feira',
  'terça-feira',
  'quarta-feira',
  'quinta-feira',
  'sexta-feira',
  'sábado',
];

const DIAS_CURTOS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

// "Dom, 07/09" — para o cabeçalho da tela de presença.
export function formatarDiaCurto(iso?: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const dia = DIAS_CURTOS[d.getDay()];
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  return `${dia}, ${dd}/${mm}`;
}

// "domingo, 13/09 às 15h" — como pedido no cabeçalho da tela.
export function formatarQuando(quando?: string | null): string {
  if (!quando) return '';
  const d = new Date(quando);
  if (Number.isNaN(d.getTime())) return quando;

  const dia = DIAS[d.getDay()];
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const hh = String(d.getHours()).padStart(2, '0');
  const min = String(d.getMinutes()).padStart(2, '0');
  const hora = min === '00' ? `${hh}h` : `${hh}h${min}`;

  return `${dia}, ${dd}/${mm} às ${hora}`;
}

// "15h" ou "15h32" — para a hora em que a presença foi confirmada.
export function formatarHora(iso?: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;

  const hh = String(d.getHours()).padStart(2, '0');
  const min = String(d.getMinutes()).padStart(2, '0');
  return min === '00' ? `${hh}h` : `${hh}h${min}`;
}

export function primeiroNome(nome: string): string {
  return nome.trim().split(/\s+/)[0] || nome;
}

const MESES = [
  'janeiro',
  'fevereiro',
  'março',
  'abril',
  'maio',
  'junho',
  'julho',
  'agosto',
  'setembro',
  'outubro',
  'novembro',
  'dezembro',
];

// "14 de março" — para a data do convite.
export function formatarDiaMes(iso?: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return `${d.getDate()} de ${MESES[d.getMonth()]}`;
}

export function formatarReais(valor: number | string): string {
  const n = typeof valor === 'number' ? valor : Number(valor);
  if (Number.isNaN(n)) return '';
  return `R$ ${n.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}